import { useState, useEffect, useRef } from "react";

export default function useScaleToFit() {
  const ref = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    function updateScale() {
      if (!ref.current) return;

      const element = ref.current;
      const parent = document.body;

      const parentWidth = parent.clientWidth;
      const parentHeight = parent.clientHeight;
      const elementWidth = element.scrollWidth + 60;
      const elementHeight = element.scrollHeight;

      // Scale only on X-axis
      const widthRatio = parentWidth / elementWidth;
      const heightRatio = parentHeight / elementHeight;
      console.log(widthRatio, parentWidth, elementWidth);
      const newScale = Math.min(widthRatio, heightRatio, 1); // don’t upscale beyond 1
      console.log(newScale);
      setScale(newScale);
    }

    updateScale();
    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, []);

  return { sectionRef:ref, scale };
}
